// src/api/shuju/dashboard.js
import request from '@/utils/request';

// ========== 核心统计卡片接口 ==========

/**
 * 获取首页统计数据（卡片数据）
 * @returns {Promise} 返回用户总数、今日新增、订单数等统计数据
 */
export const getDashboardStats = () => {
  return request.get('/shuju/getDashboardStats');
};

// ========== 趋势分析接口 ==========

/**
 * 获取近N天用户注册趋势
 * @param {Object} params - 查询参数
 * @param {number} params.days - 天数，默认7天
 * @returns {Promise} 返回日期和注册数量
 */
export const getUserTrend = (params = { days: 7 }) => {
  return request.get('/shuju/getUserTrend', { params });
};

/**
 * 获取近N天订单趋势（订单数+收入）
 * @param {Object} params - 查询参数
 * @param {number} params.days - 天数，默认7天
 * @returns {Promise} 返回日期、订单数、收入金额
 */
export const getOrderTrend = (params = { days: 7 }) => {
  return request.get('/shuju/getOrderTrend', { params });
};

/**
 * 获取近N天签到趋势
 * @param {Object} params - 查询参数
 * @param {number} params.days - 天数，默认7天
 * @returns {Promise} 返回日期和签到数量
 */
export const getSigninTrend = (params = { days: 7 }) => {
  return request.get('/shuju/getSigninTrend', { params });
};

/**
 * 获取近N天菜品新增趋势
 * @param {Object} params - 查询参数
 * @param {number} params.days - 天数，默认7天
 * @returns {Promise} 返回日期和新增菜品数量
 */
export const getDishTrend = (params = { days: 7 }) => {
  return request.get('/shuju/getDishTrend', { params });
};
// ========== 排行榜接口 ==========

/**
 * 获取热门菜品排行榜（按订单量）
 * @param {Object} params - 查询参数
 * @param {number} params.limit - 返回条数，默认10
 * @returns {Promise} 返回热门菜品列表
 */
export const getHotDishesByOrder = (params = { limit: 10 }) => {
  return request.get('/shuju/getHotDishesByOrder', { params });
};

/**
 * 获取热门菜品排行榜（按点赞量）
 * @param {Object} params - 查询参数
 * @param {number} params.limit - 返回条数，默认10
 * @returns {Promise} 返回热门菜品列表
 */
export const getHotDishesByLike = (params = { limit: 10 }) => {
  return request.get('/shuju/getHotDishesByLike', { params });
};

/**
 * 获取活跃用户排行榜（按上传菜品数）
 * @param {Object} params - 查询参数
 * @param {number} params.limit - 返回条数，默认10
 * @returns {Promise} 返回活跃用户列表
 */
export const getActiveUsers = (params = { limit: 10 }) => {
  return request.get('/shuju/getActiveUsers', { params });
};

/**
 * 获取打卡达人排行榜
 * @param {Object} params - 查询参数
 * @param {number} params.limit - 返回条数，默认10
 * @returns {Promise} 返回打卡达人列表
 */
export const getPunchLeaders = (params = { limit: 10 }) => {
  return request.get('/shuju/getPunchLeaders', { params });
};

/**
 * 获取厨房主人排行榜（成员最多的）
 * @param {Object} params - 查询参数
 * @param {number} params.limit - 返回条数，默认10
 * @returns {Promise} 返回厨房主人排行列表
 */
export const getKitchenRanking = (params = { limit: 10 }) => {
  return request.get('/shuju/getKitchenRanking', { params });
};

// ========== 待办与监控接口 ==========

/**
 * 获取需要关注的待办事项
 * @returns {Promise} 返回待办列表和汇总数据
 */
export const getTodoList = () => {
  return request.get('/shuju/getTodoList');
};

// ========== 综合接口 ==========

/**
 * 获取首页所有数据（一次性请求所有数据）
 * @returns {Promise} 返回完整的首页数据
 */
export const getDashboardData = () => {
  return request.get('/shuju/getDashboardData');
};
